import { render, staticRenderFns } from "./BasePinPoint.vue?vue&type=template&id=62ca096c&scoped=true"
import script from "./BasePinPoint.vue?vue&type=script&lang=js"
export * from "./BasePinPoint.vue?vue&type=script&lang=js"
import style0 from "./BasePinPoint.vue?vue&type=style&index=0&id=62ca096c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62ca096c",
  null
  
)

export default component.exports